export default "__VITE_ASSET__BtPaNNj6__"